
import Vue from 'vue';
import DescriptionListItem from '@/components/DescriptionListItem.vue';
import { Icon, Modal } from '@descomplica/vue-components';
import { TranslateResult } from 'vue-i18n';
import i18n from '../../../i18n';
import { SupportChatBot } from '@/helpers/supportChatBot';
import { DESCOMPLICA_SUPPORT_MANUAL_URL } from '@/settings/constants';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import StudentDocumentRequestService from '@/helpers/postgradStudentDocuments/request';
import { CourseModel } from '@descomplica/dex-models';

export default Vue.extend({
  components: {
    Icon,
    Modal,
    DescriptionListItem,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    minimumContractDays: {
      type: Number,
      required: true,
    },
    isFirstAssessment: {
      type: Boolean,
      required: true,
    },
    showSubtitle: {
      type: Boolean,
      default: false,
    },
    userHasPendingDocuments: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: this.active,
    };
  },
  computed: {
    contractTimeSubtitle(): TranslateResult {
      const { minimumContractDays } = this;

      let key = 'contractTimeSubtitleOthers';
      if (this.isFirstAssessment) key = 'contractTimeSubtitleFirst';

      return i18n.t(`yourAssessments.unavailable.${key}`, { minimumContractDays });
    },
    currentCourse(): CourseModel {
      return this.$store.getters.currentCourse;
    },
  },
  watch: {
    active(value) {
      this.isActive = value;
    },
  },
  methods: {
    updateActive(active: boolean) {
      this.$emit('update:active', active);
    },
    onCloseClick() {
      this.updateActive(false);
    },
    sendDocuments() {
      Analytics.trackEvent(EVENT_LABELS.linkClicked, {
        is_unavailable_assessments_modal: true,
        is_chat: false,
        is_descomplica_manual: false,
        is_jacad: true,
      });

      StudentDocumentRequestService.executeSSO({
        redirectToDocumentsPage: true,
        descomplicaCourseId: this.currentCourse.descomplicaCourseId,
      });
    },
    openSupportChat() {
      if (SupportChatBot.isChatLoaded()) {
        Analytics.trackEvent(EVENT_LABELS.linkClicked, {
          has_pending_documents: this.userHasPendingDocuments,
          is_unavailable_assessments_modal: true,
          is_chat: true,
          is_descomplica_manual: false,
          is_jacad: false,
        });

        SupportChatBot.openChatBot();
        return;
      }

      Analytics.trackEvent(EVENT_LABELS.linkClicked, {
        has_pending_documents: this.userHasPendingDocuments,
        is_unavailable_assessments_modal: true,
        is_chat: false,
        is_descomplica_manual: true,
        is_jacad: false,
      });
      window.open(DESCOMPLICA_SUPPORT_MANUAL_URL, '__blank');
    },
  },
});
